import styled from 'styled-components';

//info-mobile
export const GameInfoButtonDefaultBox = styled.div`
    padding-right: 20px;
    margin-right: 15px;
    border-right: 1px solid ${props => props.theme.colors.boxBorderContrast};
    cursor: pointer;
`;